import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
  getEmbarcadoresRequest: null,
  getEmbarcadoresSuccess: ['embarcadores'],
  getEmbarcadoresFailure: ['error'],
  addEmbarcadorRequest: ['embarcador', 'closeModal'],
  addEmbarcadorSuccess: ['embarcador'],
  addEmbarcadorFailure: ['error'],
  updateEmbarcadorRequest: ['embarcador', 'closeModal'],
  updateEmbarcadorSuccess: ['embarcador'],
  updateEmbarcadorFailure: ['error'],
  removeEmbarcadorRequest: ['id'],
  removeEmbarcadorSuccess: ['id'],
  removeEmbarcadorFailure: ['error'],
});

export const EmbarcadoresTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  embarcadores: [],
  isLoading: false,
  error: null,
});

const getEmbarcadoresRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getEmbarcadoresSuccess = (state, { embarcadores }) =>
  state.merge({
    embarcadores,
    isLoading: false,
    error: null,
  });

const getEmbarcadoresFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addEmbarcadorRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addEmbarcadorSuccess = (state, { embarcador }) =>
  state.merge({
    embarcadores: [...state.embarcadores, embarcador],
    isLoading: false,
    error: null,
  });

const addEmbarcadorFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateEmbarcadorRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateEmbarcadorSuccess = (state, { embarcador }) =>
  state.merge({
    embarcadores: state.embarcadores.map((item) =>
      item.id === embarcador.id ? embarcador : item
    ),
    isLoading: false,
    error: null,
  });

const updateEmbarcadorFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeEmbarcadorRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeEmbarcadorSuccess = (state, { id }) =>
  state.merge({
    embarcadores: state.embarcadores.filter((item) => item.id !== id),
    isLoading: false,
    error: null,
  });

const removeEmbarcadorFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_EMBARCADORES_REQUEST]: getEmbarcadoresRequest,
  [Types.GET_EMBARCADORES_SUCCESS]: getEmbarcadoresSuccess,
  [Types.GET_EMBARCADORES_FAILURE]: getEmbarcadoresFailure,
  [Types.ADD_EMBARCADOR_REQUEST]: addEmbarcadorRequest,
  [Types.ADD_EMBARCADOR_SUCCESS]: addEmbarcadorSuccess,
  [Types.ADD_EMBARCADOR_FAILURE]: addEmbarcadorFailure,
  [Types.UPDATE_EMBARCADOR_REQUEST]: updateEmbarcadorRequest,
  [Types.UPDATE_EMBARCADOR_SUCCESS]: updateEmbarcadorSuccess,
  [Types.UPDATE_EMBARCADOR_FAILURE]: updateEmbarcadorFailure,
  [Types.REMOVE_EMBARCADOR_REQUEST]: removeEmbarcadorRequest,
  [Types.REMOVE_EMBARCADOR_SUCCESS]: removeEmbarcadorSuccess,
  [Types.REMOVE_EMBARCADOR_FAILURE]: removeEmbarcadorFailure,
});


